import { PublicClubPostsSortingEnum } from '@alliance/clubs/domain'

const sorting: Partial<Record<PublicClubPostsSortingEnum, string>> = {
  [PublicClubPostsSortingEnum.ByDateDesc]: 'Новые',
  [PublicClubPostsSortingEnum.ByWeek]: 'За неделю',
  [PublicClubPostsSortingEnum.ByMonth]: 'За месяц',
  [PublicClubPostsSortingEnum.ByYear]: 'За год'
}

export default {
  foundItems: 'Найдено {amount} {amount, plural, one{материал} few{материала} other{материалов}}',
  empty: {
    title: 'Извините, по вашему запросу ничего не найдено',
    description: 'Можно попробовать еще раз с другими ключевыми словами, или почитать что-нибудь на',
    homepage: 'главной'
  },
  sorting: {
    mostPopular: 'Самые популярные',
    ...sorting
  }
}
